import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/bond-price-calculator',
  component: () => import('../../routes/BondPriceCalculator.svelte'),
  card: {
    id: 'bond-price-calculator',
    title: 'Bond Price Calculator',
    description: 'Calculate the fair market price of a bond from its face value, coupon rate, yield to maturity, and time to maturity. Includes period-by-period cash flow schedule.',
    icon: 'price_check',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/bond-price-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Bond Price Calculator – Bond Valuation & PV of Future Cash Flows',
    description:
      'Free bond price calculator to value a bond using the present value of its future coupon payments and face value. Supports semiannual, quarterly, and annual coupon frequency. Find out if a bond is trading at a premium, discount, or par.',
  },
};

export default meta;
